<div [style.width]="'100%'" [style.height]="'100%'" *ngIf="state.url; else uploadingIndicator">
  <ng-container *ngIf="static; else activeBoard">
    <app-pdf-hidden-page [static]="true"></app-pdf-hidden-page>
  </ng-container>
  <!-- loading pdf from url -->
  <ng-template #activeBoard>
    <app-loading [loading]="loadingPDF$ | async"></app-loading>
    <ng-container *ngFor="let position of pdfPagesPosition$ | async; let i = index">
      <app-board-pdf-page
        [pageIndex]="i"
        [pdfName]="state.name"
        [totalPagesCount]="(pdfPagesPosition$ | async)?.length"
        [position]="position"
        [uid]="state.uid"
      ></app-board-pdf-page>
    </ng-container>
  </ng-template>
</div>
<ng-template #uploadingIndicator>
  <app-resource-loading-item-canvas
    *ngIf="showUploadIndicator$ | async"
    [uploadId]="state.uid"
    [width]="state.width"
    [height]="state.height"
    [itemType]="ResourceItemModel.PDF"
  ></app-resource-loading-item-canvas>
</ng-template>
